import React from 'react'
import PropTypes from 'prop-types'
import BuildingPreview from '../BuildingPreviewV2'

const GA_SOURCE = 'Building Preview With Fav'

const BuildingPreviewWithFav = (
  {
    building,
    mobileType,
    offer,
    addressExtra = '',
    openNewTab = false,
    preConPreview = false,
    onHover = () => {},
    onMouseLeave = () => {},
    titleClass = '',
    handleClick = () => {},
    customTitleCss = '',
    showDistance,
    hideFavBtn = false,
    isFavouritesPage = false,
    gaCategory,
  }) => {
  const imageSrc = building.main_photo ||
    building.photos?.[0]?.tile_path ||
    building.photos?.[0]?.original_path
  return (
    <BuildingPreview
      offer={offer}
      salesStatus={building.sales_status}
      titleClass={titleClass}
      customTitleCss={customTitleCss}
      preConPreview={preConPreview}
      openNewTab={openNewTab}
      hideFavBtn={hideFavBtn}
      to={building.url || ''}
      alt={building.name + ' photo'}
      title={building.name}
      address={building.address_name ? building.address_name + addressExtra : ''}
      forSaleCount={building.listings_for_sale_count}
      forRentCount={building.listings_for_rent_count}
      imageSrc={imageSrc}
      mobileType={mobileType}
      onMouseLeave={onMouseLeave}
      handleClick={handleClick}
      distance={showDistance ? building.proximity : null}
      onHover={() => onHover(building)}
      building={building}
      isFavouritesPage={isFavouritesPage}
      gaCategory={gaCategory}
      gaSource={GA_SOURCE}
    />
  )
}

BuildingPreviewWithFav.propTypes = {
  building: PropTypes.shape({
    id: PropTypes.number,
    url: PropTypes.string,
    name: PropTypes.string,
    address_name: PropTypes.string,
    title: PropTypes.string,
    address: PropTypes.string,
    listings_for_sale_count: PropTypes.number,
    listings_for_rent_count: PropTypes.number,
    proximity: PropTypes.number,
    main_photo: PropTypes.string,
    alt: PropTypes.string,
    photos: PropTypes.arrayOf(PropTypes.shape({
      original_path: PropTypes.string,
      tile_path: PropTypes.string,
    })),
    sales_status: PropTypes.string,
  }),
  customTitleCss: PropTypes.string,
  mobileType: PropTypes.string,
  offer: PropTypes.string,
  handleClick: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onHover: PropTypes.func,
  preConPreview: PropTypes.bool,
  openNewTab: PropTypes.bool,
  showDistance: PropTypes.bool,
  hideFavBtn: PropTypes.bool,
  titleClass: PropTypes.string,
  addressExtra: PropTypes.string,
  isFavouritesPage: PropTypes.bool,
  gaCategory: PropTypes.string,
}
export default BuildingPreviewWithFav
